import { useState } from "react";
import { Bot, X } from "lucide-react";
import AIAssistant from "./AIAssistant.jsx";

/**
 * Floating AI assistant button + slide-in panel.
 * Renders on top of all authenticated pages via ProtectedLayout.
 */
export default function AIAssistantButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating action button */}
      <button
        onClick={() => setOpen((v) => !v)}
        className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-teal-600 text-white shadow-lg hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
        aria-label={open ? "Close AI assistant" : "Open AI assistant"}
      >
        {open ? <X className="h-5 w-5" /> : <Bot className="h-5 w-5" />}
      </button>

      {/* Slide-in chat panel */}
      {open && (
        <>
          {/* Backdrop (mobile only) */}
          <div
            className="fixed inset-0 z-30 bg-black/20 md:hidden"
            onClick={() => setOpen(false)}
          />

          <div className="fixed bottom-20 right-6 z-40 flex h-[560px] w-[440px] max-h-[calc(100vh-100px)] flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl">
            <AIAssistant onClose={() => setOpen(false)} />
          </div>
        </>
      )}
    </>
  );
}
